import {erpMethodApi} from "@dladio/service";

export const extendedApiSlice = erpMethodApi.injectEndpoints({
    endpoints: builder => ({
        generateInvoice: builder.query({
            query: ({ method, body }) => ({
                url: `${method}`,
                method: 'POST',
                body: body
            })
        })
    })
})

export const { useGenerateInvoiceQuery } = extendedApiSlice